// sync with Pricing group model: https://trackdesk.admin.datocms.com/editor/item_types/M21VCLYBTqWF7z8W-p89VQ/items

export enum PricingGroup {
	SelfService = 'self-service',
	Business = 'business',
	Network = 'network',
}
